module.exports = __webpack_public_path__ + "static/media/logo.0b65d26a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.svg
// module id = 462
// module chunks = 0